import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./i18n";
import "./index.css";

const rootElement = document.getElementById("root");
if (rootElement === null) {
  throw new Error("The page has no #root element to render the app into.");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
